module.exports = __webpack_public_path__ + "static/media/crutch.f50b9bbe.svg";